import { Badge } from '@mui/material'
import { styled } from '@mui/system'

const BadgeSelected = styled(Badge)(() => ({
    top: '0',
    right: '0',
    height: '32px',
    width: '32px',
    borderRadius: '50%',
}))

export default BadgeSelected
